{
  "bookButtonLabel": "立即预约",
  "bookText": "<h3>在线预约：</h3>\n<ul>\n  <li>⏱️  <strong>快捷方便 -</strong> 15 分钟以内</li>\n  <li>🌙  <strong>随时预约 -</strong> 下班后也可以</li>\n  <li>🗓️  <strong>选择适合您的时间</strong></li>\n  <li>🔐  <strong>无纸化 -</strong> 安全准确</li>\n</ul>",
  "declineButtonLabel": "拒绝此预约邀请",
  "declineText": "<h3>您没有预期或不想进行这个检查？</h3>\n<p>请选择一个原因告诉我们：</p>",
  "helpMessage": "<h3>想与我们通话吗？</h3>\n<p>我们的友善团队乐意为您提供帮助：<br/><a><strong>☎️ {{phone}}</strong></a>（然后按 <strong>选项 2</strong>）<br/>周一至周五，上午 8 点至下午 5 点。</p>\n<p><em>我们的团队可能只能说英语 — 感谢您的理解。</em></p>",
  "info": "<h3>想了解更多关于这个检查吗？</h3>\n<p>观看一个简短的视频，了解检查流程以及如何做好准备。</p>",
  "select": {
    "badTiming": "时间不方便",
    "cantAfford": "现在负担不起",
    "didntKnowReferred": "我不知道有人为我转诊了",
    "hadElsewhere": "我已经在别处做过了",
    "notNecessary": "我认为没有必要",
    "placeholder": "请选择原因"
  },
  "text": "<p>您的全科医生 <strong>{{requestingPractitioner.displayName}}</strong> 已将您转诊给 <strong>{{practitioners.0.name}}</strong> 进行 <strong>{{procedure.displayName}}</strong>。</p>",
  "textNoSpecialist": "<p>您的全科医生 <strong>{{requestingPractitioner.displayName}}</strong> 已将您转诊进行 <strong>{{procedure.displayName}}</strong>。</p>",
  "title": "您好，{{patient.nameGiven}}。<br /> 现在是预约您的检查的时候了。",
  "videoButtonLabel": "播放关于进行内窥镜检查的视频",
  "videoCaption": "我们建议您在预约前观看此视频。",
  "videos": {
    "GAS": "Jdaob00qXgETZuakhvxfdR3kb1lcpJIIm84mMoo9o7Rw",
    "fallback": "Jdaob00qXgETZuakhvxfdR3kb1lcpJIIm84mMoo9o7Rw"
  }
}
